/**
 * Минимальная инициализация Firebase App для FCM на странице.
 * Service worker использует отдельный compat-бандл из CDN (firebase-messaging-sw.js).
 */
import {initializeApp} from 'firebase/app';
import config from '@appConfig';

let firebaseApp = null;
/** Один общий промис, чтобы не вызывать initializeApp повторно. */
let initPromise = null;

function isFirebaseConfigured() {
    return Boolean(
        config.FIREBASE_API_KEY
        && config.FIREBASE_PROJECT_ID
        && config.FIREBASE_APP_ID
        && config.FIREBASE_MESSAGING_SENDER_ID,
    );
}

function buildFirebaseConfig() {
    return {
        apiKey: config.FIREBASE_API_KEY,
        authDomain: config.FIREBASE_AUTH_DOMAIN,
        projectId: config.FIREBASE_PROJECT_ID,
        storageBucket: config.FIREBASE_STORAGE_BUCKET,
        messagingSenderId: config.FIREBASE_MESSAGING_SENDER_ID,
        appId: config.FIREBASE_APP_ID,
    };
}

/**
 * Инициализирует Firebase App для FCM.
 * Вызывается из firebaseMessaging.js перед getMessaging/getToken.
 */
export function initFirebase() {
    if (initPromise) {
        return initPromise;
    }

    initPromise = (async () => {
        if (!isFirebaseConfigured()) {
            console.warn('Firebase: не заданы переменные окружения, инициализация пропущена.');
            return null;
        }

        try {
            firebaseApp = initializeApp(buildFirebaseConfig());
            return firebaseApp;
        } catch (error) {
            console.warn('Firebase init failed', error);
            return null;
        }
    })();

    return initPromise;
}

export function getFirebaseApp() {
    return firebaseApp;
}
